<template>
  <ModalConfirmation
    :message="confirmMessage"
    @accept="closeConfirmModalAsync(deleteBannerTransaction)"
    @deny="closeConfirmModalAsync"
    v-show="showConfirmModal"
  />
  <div class="wrapper-banners">
    <div class="above-info">
      <p>Banners</p>
      <input
        type="file"
        ref="fileReference"
        hidden
        @change="createBannerTransaction"
        @click="$event.target.value = ''"
      />
      <StandardButton
        :buttonLabel="'Crear banner'"
        @click="$refs.fileReference.click()"
      />
    </div>

    <ul class="wrapper-banners">
      <li class="banner" v-for="(banner, index) in banners" :key="index">
        <div class="banner-number">
          <p>Banner {{ index + 1 }}</p>
        </div>
        <DeleteButton @click="selectDeletedBanner(banner)" :type="'Delete'" />
        <img :src="banner.path" class="banner-image" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalConfirmation from "@/components/commons/modals/ModalConfirmation.vue";
import { bannersUse } from "@/ux/banners/use/bannersUse";
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import DeleteButton from "@/components/commons/controls/DeleteButton.vue";
import { inject, ref } from "vue";
import { spinnerProcessKey, successProcessKey } from "@/main";
import { confirmCancelMessageManager } from "@/ux/utils/managers/confirmCancelMessageManager";
import { Banner } from "@/business/banner/domain/banner";

export default defineComponent({
  name: "BannersView",
  components: {
    ModalConfirmation,
    StandardButton,
    DeleteButton,
  },

  setup() {
    const successProcess = inject(successProcessKey)!;
    const { showSuccessModal } = successProcess;

    const spinnerProcess = inject(spinnerProcessKey)!;
    const { offSpinnerState, onSpinnerState } = spinnerProcess;

    const {
      showConfirmModal,
      openConfirmModal,
      closeConfirmModalAsync,
      confirmMessage,
    } = confirmCancelMessageManager();

    const fileReference = ref(null);

    const {
      createBannerOperation,
      deleteBannerOperation,
      selectedBanner,
      banners,
    } = bannersUse();

    async function createBannerTransaction(event: any) {
      const bannerImage = event.target.files[0];
      try {
        await onSpinnerState();
        await createBannerOperation(bannerImage);
        await offSpinnerState();
        showSuccessModal("Banner creado correctamente");
      } catch (exception) {
        await offSpinnerState();
        throw exception;
      }
    }

    async function selectDeletedBanner(banner: Banner) {
      selectedBanner.value = banner;
      openConfirmModal("¿Estás seguro de eliminar el banner?");
    }

    async function deleteBannerTransaction(): Promise<void> {
      try {
        await onSpinnerState();
        await deleteBannerOperation();
        await offSpinnerState();
        showSuccessModal("El banner ha sido eliminado correctamente.");
      } catch (exception) {
        await offSpinnerState();
        throw exception;
      }
    }

    return {
      fileReference,
      showConfirmModal,
      openConfirmModal,
      closeConfirmModalAsync,
      confirmMessage,
      banners,
      selectDeletedBanner,
      deleteBannerTransaction,
      createBannerTransaction,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/banners/styles/bannersStyle";
</style>
